import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerSelectComponent } from './customer-select.component';
import { TranslocoModule } from '@jsverse/transloco';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormErrorModule, SelectModule } from '@eg/ui';

@NgModule({
  declarations: [CustomerSelectComponent],
  imports: [CommonModule, SelectModule, TranslocoModule, FlexLayoutModule, FormErrorModule],
  exports: [CustomerSelectComponent],
})
export class CustomerModule {}
